<template>
  <div class="wg-row" style="justify-content:center;">
    <div class="com-anm22-page-title" style="font-size:24px;">
      {{ $anm22.strLang(lang, 'Quick links', 'Link rapidi') }}
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, 'Click on the link to copy', 'Cliccare sul link per copiare') }}
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div
        v-for="l in links"
        :key="'link-' + l.id"
        class="wg-row"
        style="justify-content:center;" 
        @click="copyToClipboard(l.url)">
      <div class="link">
        <div class="com-anm22-app-text-xxl">
          {{ l.label }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div 
            class="com-anm22-app-text-l" 
            style="cursor:pointer;" 
            :title="$anm22.strLang(lang, 'Click to copy', 'Cliccare per copiare')"
            >
          {{ l.url }} 
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="qrcode">
        <qriously :value="l.url" :size="150" />
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
    </div>
    
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    license: {
      type: Object,
      default: {}
    },
    timezone: {
      type: String,
      default: "Europe/Rome"
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    links() {
      const links = [
        // base
        {
          id: 'base',
          url: process.env.VUE_APP_FRONT_DOMAIN + process.env.BASE_URL + '?license=' + this.licenseSelected,
          label: this.$anm22.strLang(this.lang, 'Employee link', 'Link dipendente'),
        }
      ];
      if(this.license.config.modules.delivery.enabled) {
        links.push({
          id: 'order',
          url: process.env.VUE_APP_FRONT_DOMAIN + process.env.BASE_URL + 'order?license=' + this.licenseSelected,
          label: this.$anm22.strLang(this.lang, 'Order link', 'Link ordinazione'),
        });
      } else {
        links.push({
          id: 'menu',
          url: process.env.VUE_APP_FRONT_DOMAIN + process.env.BASE_URL + 'menu?license=' + this.licenseSelected,
          label: this.$anm22.strLang(this.lang, 'Menu link', 'Link menù'),
        });
      }
      return links;
    },
    printers() {
      return this.$store.getters["foodPrinters/getByLicense"](
        this.license.id
      ).filter(p => p.printMode.text);
    },
  },
  methods: {
    copyToClipboard(text) {
      this.$anm22.copyTextToClipboard(text);
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "License URL successfully copied",
          "URL licenza copiato con successo"
        ),
        type: "confirm"
      });
    },
    // print(ref, pid) {
    //   // if printer undefined print with browser
    //   if(pid) {
    //     const content = new WorldPrintContent();
    //     content.printMode = 'text';

    //     let body = '', line_width = 45;

    //     // title
    //     body += this.report.title;
    //     body += "\n";
    //     // header
    //     let s_header = '';
    //     this.report.header.forEach((h,i) => {
    //       const field_width = Math.round(line_width / 100 * h.width);
    //       if(i === 0) {
    //         s_header += h.label.padEnd(field_width, ' ');
    //       } else {
    //         s_header += h.label.padStart(field_width, ' ');
    //       }
    //     });
    //     body += "\n" + s_header;
    //     // lines
    //     this.report.lines.forEach(l => {
    //       let s_line = '';
    //       l.forEach((e,i) => {
    //         const field_width = Math.round(line_width / 100 * this.report.header[i].width);
    //         if(e.length > field_width) {
    //           e = e.substring(0, field_width);
    //         }
    //         if(i === 0) {
    //           s_line += e.padEnd(field_width, ' ');
    //         } else {
    //           s_line += e.padStart(field_width, ' ');
    //         }
    //       });
    //       body += "\n" + s_line;
    //     });

    //     content.text = body;
    //     window['world_printer_'+pid].print(content);

    //   } else {
    //     const html = document.getElementById("report").cloneNode(true);

    //     // Get all stylesheets HTML
    //     const headElements = [],
    //       inserted = [];
    //     for (const node of [...document.querySelectorAll('link[href$=".css"], style')]) {
    //       // stylesHtml += node.innerHTML;
    //       if (node.tagName === "STYLE") {
    //         const elem = document.createElement("style");
    //         elem.type = "text/css";
    //         elem.innerHTML = node.innerHTML;
    //         headElements.push(elem);
    //       } else {
    //         if (!inserted.find(s => s === node.href)) {
    //           inserted.push(node.href);
    //           const elem = document.createElement("link");
    //           elem.type = "text/css";
    //           elem.rel = "stylesheet";
    //           elem.href = node.href;
    //           headElements.push(elem);
    //         }
    //       }
    //     }
    //     console.log(html);
    //     this.$anm22.print(html, headElements);
    //   }
    // },
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
.link {
  cursor: pointer;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  &:hover {
    background-color: #ddd;
  }
}
</style>
